<template>
    <div class="c-m-error-state">
        <div class="c-m-error-state__inner">
            <img v-if="type === '404' && image" v-bind:src="image" alt="404" />
            <icon
                v-if="(!hideIcon && !image) || (!hideIcon && type !== '404')"
                class="c-m-error-state__hero-icon"
                :icon="icon"
            />
            <p class="c-m-error-state__heading h2">{{ heading }}</p>

            <div
                v-if="type === '404' && !isLoading && text404 && text404 !== ''"
                v-html="text404"
            />
            <div v-else class="c-m-error-state__body" v-html="body"></div>

            <div v-if="button.label" class="c-m-error-state__action">
                <button-link
                    v-if="button.to"
                    :modifiers="button.classes"
                    :link="button.to"
                    :label="button.label"
                    :icon="button.icon"
                ></button-link>
                <button-link-external
                    v-else-if="button.url"
                    :modifiers="button.classes"
                    :link="button.url"
                    :label="button.label"
                    :icon="button.icon"
                ></button-link-external>
                <button-function
                    v-else-if="button.function"
                    :modifiers="button.classes"
                    @buttonClicked="button.function()"
                    :label="button.label"
                    :icon="button.icon"
                ></button-function>
            </div>

            <div v-if="type === '404'">
                <div v-if="!isLoading && links" class="c-m-error-state__body">
                    <h3>Hjälpsamma länkar:</h3>
                    <div
                        v-for="(linkObj, index) in links"
                        :key="`link-${index}`"
                    >
                        <a href="`${linkObj.link.url}`">{{
                            linkObj.link.title
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../atoms/AtomIcon.vue";
import ButtonLink from "../atoms/AtomButtonLink.vue";
import ButtonLinkExternal from "../atoms/AtomButtonLinkExternal.vue";
import ButtonFunction from "../atoms/AtomButton.vue";

import { mapGetters } from "vuex";
import {
    GET_404_Text,
    GET_404_LINKS,
    IS_LOADING,
    GET_404_Image
} from "../../../store/store-models/meta-model";

export default {
    props: {
        heading: {
            type: String,
            default: "Oj, något gick fel!"
        },
        body: {
            type: String,
            default:
                '<p>Försök igen senare.</p><p>Om problemet kvarstår kan du kontakta kundtjänst på <a href="mailto:info@brabyggare.se">info@brabyggare.se</a></p>'
        },
        icon: {
            type: String,
            default: "sentiment_dissatisfied"
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        button: {
            type: Object,
            default: function() {
                return {};
            }
        },
        type: {
            type: String,
            default: null
        },

        metaObject: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    components: {
        Icon,
        ButtonLink,
        ButtonLinkExternal,
        ButtonFunction
    },
    computed: {
        ...mapGetters({
            links: GET_404_LINKS,
            text404: GET_404_Text,
            isLoading: IS_LOADING,
            image: GET_404_Image
        }),

        title: function() {
            return this.metaObject.title
                ? {
                      title: `Sidan för ${this.metaObject.title} är stängd`
                  }
                : {};
        }
    },
    metaData() {
        return this.title;
    }
};
</script>

<style scoped>
.Image404 {
    margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeErrorState.vue